/**
 * Leaflet-specific configuration and icon creation
 */
import L from 'leaflet';
import { sportTypeColors } from '../../utils/mapConfig';

// Leaflet tile layer configuration
export const leafletTileConfig = {
  // OpenStreetMap tile layer
  tileLayerUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
};

/**
 * Create custom Leaflet icon for different sport types
 * @param sportType - Type of sport/place
 * @returns Leaflet DivIcon instance
 */
export const createCustomIcon = (sportType: string): L.DivIcon => {
  const color = sportTypeColors[sportType] || sportTypeColors.default;

  const svgIcon = `
    <svg width="32" height="42" viewBox="0 0 32 42" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 0C7.163 0 0 7.163 0 16c0 16 16 26 16 26s16-10 16-26c0-8.837-7.163-16-16-16z"
            fill="${color}"
            stroke="#fff"
            stroke-width="2"/>
      <circle cx="16" cy="16" r="6" fill="#fff"/>
    </svg>
  `;

  return L.divIcon({
    className: 'custom-map-marker',
    html: svgIcon,
    iconSize: [32, 42],
    iconAnchor: [16, 42],
    popupAnchor: [0, -42],
  });
};

/**
 * Create user location icon for Leaflet
 * @returns Leaflet DivIcon instance
 */
export const createUserLocationIcon = (): L.DivIcon => {
  const svgIcon = `
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="14" fill="#4A90E2" stroke="#fff" stroke-width="3"/>
      <circle cx="16" cy="16" r="6" fill="#fff"/>
    </svg>
  `;

  return L.divIcon({
    className: 'user-location-marker',
    html: svgIcon,
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16],
  });
};